// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"LoadingSpinner_spinnerContainer__0bkZu","spinner":"LoadingSpinner_spinner__tUn7Z","spin":"LoadingSpinner_spin__hesF4"};